/**
 * Format the event time strings stored as `"HH:MM"` (from <input type="time">)
 * into friendly 12-hour US format with an optional timezone label.
 *
 * Events are stored as venue-local `"HH:MM"` plus a host-chosen `timezone`
 * label (ET/CT/MT/PT/AKT/HT). We do NOT auto-convert to the viewer's tz
 * because that would actively mislead a Seattle user looking at a Portland
 * event. The label makes the contract explicit.
 *
 * Examples:
 *   formatEventTime("14:30")                 -> "2:30 PM"
 *   formatEventTime("09:00", "11:00", "PT")  -> "9:00 AM – 11:00 AM PT"
 *   formatEventTime("17:00", "", "ET")       -> "5:00 PM ET"
 *   formatEventTime("", "")                  -> "TBD"
 */
export function formatEventTime(start, end, tz) {
  const s = formatOne(start);
  const e = formatOne(end);
  let core;
  if (!s && !e) return 'TBD';
  if (s && !e) core = s;
  else if (!s && e) core = e;
  else core = `${s} – ${e}`;
  const tzLabel = (tz || '').toString().trim();
  return tzLabel ? `${core} ${tzLabel}` : core;
}

function formatOne(t) {
  if (!t || typeof t !== 'string') return '';
  const trimmed = t.trim();
  if (!trimmed) return '';
  // Already formatted (e.g. "2:30 PM") — pass through.
  if (/AM|PM|am|pm/.test(trimmed)) return trimmed;
  const m = trimmed.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
  if (!m) return trimmed;
  const hh = parseInt(m[1], 10);
  const mm = m[2];
  if (Number.isNaN(hh) || hh < 0 || hh > 23) return trimmed;
  const period = hh >= 12 ? 'PM' : 'AM';
  const h12 = hh % 12 === 0 ? 12 : hh % 12;
  return `${h12}:${mm} ${period}`;
}
